<template>
  <div style="display: flex; flex-direction: row; width: 100%;" class="justify-space-between align-items-center">
    <div style="height: 30px; display: flex; align-content: center; justify-content: center; margin-top: 14px;">
      {{ item.full_name }}
    </div>
    <div class="d-flex aling-center justify-center">
      <v-chip label outlined class="ml-2">
        Users {{ item.users }}
      </v-chip>
      <v-chip label outlined class="ml-2">
        Save h {{ item.total_hours_saved }}
      </v-chip>
      <v-chip class="ml-2" v-if="item.epesis_pro" color="primary">
        PRO
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item']
}
</script>